<template>
<v-flex xs12 v-bind="{ [`sm${size}`]: true }" pa-2 ma-2>
              <span class="caption"
                v-if="property.type === 'label'"
                v-show="visible"
              >
              {{property.label}}:
              </span>
              <span class="caption"
                v-if="property.type === 'label'"
                v-show="visible"
              >
              {{resolvedApi}}
              </span>
              <v-text-field
                autocomplete="new-password"
                v-if="property.password"
                :type="showPassword ? 'text' : 'password'"
                v-model="property.value"
                :label="property.label"
                :rules="[rules.required]"
                :placeholder="property.hintText"
                :hint="property.shortDescription"
                persistent-hint
                :readonly="locked"
                v-show="visible"
                :clearable="!locked"
                @input="changed"
              >
                <v-tooltip v-if="property.helpText" left max-width="25%">
                  <template v-slot:activator="{on}">
                    <v-icon>fas fa-info-circle</v-icon>
                  </template>
                  <span v-text="property.helpText"></span>
                </v-tooltip>
              </v-text-field>
              <v-text-field
                autocomplete="new-password"
                v-if="!property.password && property.type === 'text'"
                v-model="property.value"
                :label="property.label"
                :rules="[rules.required, rules.email, rules.format]"
                :placeholder="property.hintText"
                :hint="property.shortDescription"
                persistent-hint
                :readonly="locked"
                v-show="visible"
                :clearable="!locked"
                @input="changed"
              >
                <v-tooltip v-if="property.helpText" left max-width="25%">
                  <template v-slot:activator="{on}">
                    <v-icon>fas fa-info-circle</v-icon>
                  </template>
                  <span v-text="property.helpText"></span>
                </v-tooltip>

              </v-text-field>
              <v-textarea
                v-if="!property.password && property.type === 'textarea'"
                v-model="property.value"
                :label="property.label"
                :rules="[rules.required, rules.email, rules.format]"
                :placeholder="property.hintText"
                :hint="property.shortDescription"
                persistent-hint
                :readonly="locked"
                v-show="visible"
                :clearable="!locked"
                @input="changed"
              >
                <v-tooltip v-if="property.helpText" left max-width="25%">
                  <template v-slot:activator="{on}">
                    <v-icon>fas fa-info-circle</v-icon>
                  </template>
                  <span v-text="property.helpText"></span>
                </v-tooltip>
              </v-textarea>
              <v-checkbox
                v-if="property.type === 'checkbox'"
                v-model="property.value"
                :rules="[rules.required]"
                :label="property.label"
                :readonly="locked"
                v-show="visible"
                @change="changed"
              >
                <v-tooltip v-if="property.helpText" left max-width="25%">
                  <template v-slot:activator="{on}">
                    <v-icon>fas fa-info-circle</v-icon>
                  </template>
                  <span v-text="property.helpText"></span>
                </v-tooltip>
              </v-checkbox>
              <v-select
                v-if="property.listOptions && property.type === 'list'"
                v-model="property.value"
                :items="listOptions"
                :rules="[rules.required]"
                v-show="visible"
                :label="property.label"
                :readonly="locked"
                @input="changed"
                :clearable="!locked"
              >
                <v-tooltip v-if="property.helpText" left max-width="25%">
                  <template v-slot:activator="{on}">
                    <v-icon>fas fa-info-circle</v-icon>
                  </template>
                  <span v-text="property.helpText"></span>
                </v-tooltip>

              </v-select>


              <v-layout wrap v-if="property.type === 'upload'"
              @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      :class="{ 'grey lighten-2': dragover }"
              >
                <v-flex xs12 style="border: 5px dashed grey;align-items: center;text-align: center;">
              <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
                fa-light fa-cloud-arrow-up
              </v-icon>
              <p v-text="property.hintText">
              </p>
            </v-flex>
            <v-flex xs12>&nbsp;</v-flex>
            <v-flex xs12 style="align-items: center;text-align: center;">
            <v-btn
              @click="upload(property)" v-show="visible">
              {{property.label}}
              </v-btn>
            </v-flex>
            </v-layout>

              <v-btn
                v-if="property.type === 'link'"
                @click="linkClick(property)"
                v-show="visible">
                  {{property.label}}
              </v-btn>

              <v-tooltip v-if="property.helpText && property.type === 'link'" left max-width="25%">
                <template v-slot:activator="{on}">
                  <v-icon>fas fa-info-circle</v-icon>
                </template>
                <span v-text="property.helpText"></span>
              </v-tooltip>

              <div v-if="property.shortDescription && ((property.type === 'link') || (property.type === 'checkbox'))">
                {{property.shortDescription}}
              </div>
              <div v-if="property.alert">
                <v-alert :value="true" type="info">{{property.alert}}</v-alert>
              </div>
              <v-dialog
                v-model="linkdialog"
                hide-overlay
                persistent
                width="300"
              >
                <v-card
                  color="primary"
                  dark
                >
                  <v-card-text>
                    Please complete the steps in the adjacent tab or close the tab
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
                </v-card>
              </v-dialog>
    </v-flex>
</template>
<script>
import _ from 'lodash'
import FileService from '../../services/FileService';

export default {
    data() {
      return {
        size: 5,
        showPassword: false,
        linkdialog: false,
        listOptions: [],
        dragover: false,
        url: '#',
        rules: {
          required: value => !this.property.visibleEx || !this.property.required || !!value || 'Required.',
          email: value => !this.property.validation.includes('email') || /.+@.+/.test(value) || 'Invalid format',
          format: value => !this.property.validation.includes('format:') || this.testFormat(value, this.property.validation) || 'Invalid format'
        },
        resolvedApi: ''
      }
    },
    props: {
      property: Object,
      locked: Boolean,
      visible: Boolean
    },
    async created() {
      if (this.property.length) {
        this.size = this.property.length
      }
      this.resolvedApi = await this.resolveApi(this.property.value || this.property.defaultValue)

      if (this.property.listOptions && this.property.type === 'list') {
        await this.setListOptions(this.property.listOptions)
      }

    },
    methods: {
      async resolveApi(val) {
        if (this.isApi(val)) {
          return await this.getApi(val)
        } else {
          return val
        }
      },
      async linkClick(property) {
        var self = this
        if (this.isPost(property.value || property.defaultValue)) {
          await this.postApi(property.value || property.defaultValue)
          self.$emit('linkedwindowclosed')
          return
        }

        if (this.isApi(property.value)) {
          this.url = await this.getApi(property.value)
        } else if (this.isApi(property.defaultValue)) {
          this.url = await this.getApi(property.defaultValue)
        } else {
          return
        }

        self.$emit('linkedwindowopening', this.url)
        var url = this.url
        //this.linkdialog = true
        var childWindow
        setTimeout(() => {
          childWindow = window.open(url, '_blank')
          // console.log('Child Window ' + childWindow)
        }, 0);
        var checkWindowClose
        setTimeout(() => {
          checkWindowClose = setInterval(function () {
              if (childWindow.closed) {
                // console.log('Child window closed')
                clearInterval(checkWindowClose);
                this.linkdialog = false
                self.$emit('linkedwindowclosed')
              } else {
                // console.log('Child window not closed')
                  // check the URL if childWindow has been redirected to somewhere
                  try {
                    // cross-origin exception will occur if the URL is in different domain
                    if (childWindow.document.URL !== url) {
                      clearInterval(checkWindowClose);
                      this.linkdialog = false
                    }
                  } catch (err) {
                    //console.error(err)
                    // just ignore the error and do nothing
                  }
                }
              }, 1000)
        },1000)
      },
      testFormat(value, validation) {
        if (_.isNull(value)) {
          return true
        }
        let p = validation.indexOf('format:')
        let q = validation.indexOf(',', p)
        if (q < 0) {
          q = validation.length
        }
        let expr = validation.substring(p+7, q)
        let regx = new RegExp(expr)
        return regx.test(value)
      },
      async setListOptions(optionsStr) {
        if (optionsStr.indexOf('api:') < 0) {
          this.listOptions = optionsStr.split(',')
          return
        }
        let p = optionsStr.indexOf('api:')
        let q = optionsStr.indexOf(',', p)
        if (q < 0) {
          q = optionsStr.length
        }
        let url = optionsStr.substring(p+4, q)
        let finalValue = await this.$store.dispatch('systems/getApi', url)
        _.forEach(finalValue, (itm) => { itm.value = '' + itm.value })
        this.listOptions = finalValue
      },
      async getApi(value) {
        let p = value.indexOf('api:')
        let q = value.indexOf(',', p)
        if (p < 0) {
          return value
        }
        if (q < 0) {
          q = value.length
        }
        let url = value.substring(p+4, q)
        let finalValue = await this.$store.dispatch('systems/getApi', url)
        return finalValue
      },
      isApi(value) {
        return (_.isString(value)) && (value.indexOf('api:') >= 0)
      },
      async postApi(value) {
        let p = value.indexOf('post:')
        let q = value.indexOf(',', p)
        if (p < 0) {
          return value
        }
        if (q < 0) {
          q = value.length
        }
        let url = value.substring(p+5, q)
        let finalValue = await this.$store.dispatch('systems/postApi', url)
        return finalValue
      },
      isPost(value) {
        return (_.isString(value)) && (value.indexOf('post:') >= 0)
      },
      changed() {
        this.$emit('change', this.property)
      },
      async upload(property) {
        let self = this;
        try {
          let file = await FileService.selectFile();
          if (!file.name.includes('.csv')) {
            alert('Non csv files are not allowed')
            return
          }
          try {
            let uploadResponse = await FileService.upload(file);
            if (uploadResponse.status === 200) {
              alert("File uploaded")
            } else {
              alert(uploadResponse.status + ' ' + uploadResponse.statusText + ' ' + uploadResponse.data)
            }
          } catch (err) {
              console.error(err)
          }
        } catch (err) {
          console.error(err)
        }
      },
    onDrop(e) {
      this.dragover = false;
      let files = e.dataTransfer.files
      const noncsvs = _.find(files, (f) => { return !f.name.includes('.csv') })
      if (noncsvs) {
        alert('Non csv files are not allowed')
        return
      }
      _.forEach(e.dataTransfer.files, async function(file) {
          try {
            console.log(file)
            let uploadResponse = await FileService.upload(file);
            if (uploadResponse.status === 200) {
              alert("File uploaded")
            } else {
              alert(uploadResponse.status + ' ' + uploadResponse.statusText + ' ' + uploadResponse.data)
            }
         } catch (err) {
              console.error(err)
          }
        });
    }
    }
}
</script>
